module.exports = __webpack_public_path__ + "static/img/case_detail_03_6.842fe22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_03_6.png
// module id = X0Wd
// module chunks = 34